/**
 * ------------------------------------------------------------------------
 * COLLAPSE JS
 * ------------------------------------------------------------------------
 */

var fnmap = {
    'toggle': 'toggle',
    'show': 'add',
    'hide': 'remove'
};

var collapse = function(element) {
    var selector = element.getAttribute('data-target');

    document.querySelector(selector).classList[fnmap['toggle']]('show');
};